import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import useLayoutEffectIsomorphic from '../useLayoutEffectIsomorphic';

var useHasSmoothScrollBehavior = function useHasSmoothScrollBehavior() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasSmoothScroll = _useState2[0],
      setHasSmoothScroll = _useState2[1]; // we only want to execute this after mount (due to getComputedStyle) and otherwise can safely silence layout effect warning


  useLayoutEffectIsomorphic(function () {
    // using random string to avoid conflicts
    var scrollDivId = "cui-".concat(Math.random().toString(36).substring(7));
    var scrollDiv = document.createElement('div');
    scrollDiv.setAttribute('id', scrollDivId);
    scrollDiv.style.scrollBehavior = 'smooth';
    document.body.appendChild(scrollDiv);

    if (getComputedStyle(scrollDiv).scrollBehavior === 'smooth') {
      setHasSmoothScroll(true);
    }

    document.body.removeChild(scrollDiv);
  }, []);
  return hasSmoothScroll;
};

export default useHasSmoothScrollBehavior;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/useHasSmoothScroll/index.js
// module id = 2023
// module chunks = 12